import { render, staticRenderFns } from "./patientInfo.vue?vue&type=template&id=0bddcbe3&scoped=true"
import script from "./patientInfo.vue?vue&type=script&lang=js"
export * from "./patientInfo.vue?vue&type=script&lang=js"
import style0 from "./patientInfo.vue?vue&type=style&index=0&id=0bddcbe3&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bddcbe3",
  null
  
)

export default component.exports